/**
 * paradisesociety 3D logo moods - the cursed cat's faces (animations inside the logo GLB:
 * Blink, Wink, Dollars, Happy, Surprised, Hearts, Dead, Sleepy, Cursed).
 *
 *  - a click on the logo                        -> Blink (the only time it blinks)
 *  - 3 quick clicks on the logo                 -> Cursed (+ the anger mark, if it is on) and the game starts
 *  - a click anywhere else                       -> Happy (played faster, short)
 *  - add to cart                                 -> Dollars
 *  - a click on the drip / accessories collection -> Hearts (and again on the page it opens)
 *  - nothing happening for 10 s                  -> Sleepy, and it stays asleep until something happens
 *
 * A logo click waits a moment for more clicks before going to the home page (so 3 clicks can happen at all).
 * A stronger face is never cut short by a weaker one. Without the animations in the GLB (an older model)
 * everything quietly does nothing. Safe to load twice / after section reloads (one set of listeners).
 */
(function () {
  'use strict';

  if (window.__fkxLogoMoods) return;

  var SELECTOR = 'model-viewer.header__heading-logo-3d, model-viewer#glb-logo-viewer';
  var WRAP = '.fkx-logo-wrap, .fkx-glb-logo';
  var IDLE_MS = 10000;
  var LOGO_NAV_DELAY_MS = 420;     // a logo click waits this long for the next one (3 in a row: Cursed)
  var HAPPY_SPEED = 3.0;            // Happy, but short (~0.6 s)
  var HEARTS_SPEED = 1.7;           // Hearts, a little shorter (~1 s)
  var CARRY_KEY = 'fkxLogoMood';    // a face to show on the next page (a collection opened)
  var PRIORITY = { Cursed: 6, Dollars: 5, Hearts: 4, Surprised: 3, Happy: 2, Wink: 2, Blink: 2, Sleepy: 1 };
  var HEARTS_LINK = /\/collections\/(drip|accessor|akcesori)/i;
  // Cursed eyes: the GLB's pink glow -> the mouth's red (linear RGBA, no glow; renders ~#d0001c like the mouth)
  var CURSED_EYES_MATERIAL = 'CursedGlow';
  var CURSED_EYES_COLOR = [0.45, 0, 0.007, 1];
  var ADD_TO_CART =
    'button[name="add"], [type="submit"][name="add"], form[action*="/cart/add"] [type="submit"], ' +
    '.quick-add__submit, product-form button[type="submit"]';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = null;
  var safety = 0;
  var idleTimer = 0;
  var asleep = false;
  var SLEEP_HOLD_AT = 0.8;          // seconds into Sleepy where the eyes are fully sleepy (held while idle)
  var logoClicks = 0;
  var logoTimer = 0;
  var GAME_CLICKS = 3;            // 3 quick clicks: Cursed + the easter egg z grą (snippets/fkx-game-trigger.liquid)
  var GAME_GAP_MS = 1000;
  var gameStreak = 0;
  var gameLast = 0;
  var downX = 0;
  var downY = 0;
  var moved = false;
  var pending = null;

  function viewers() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function ready(mv) {
    return mv.loaded && mv.availableAnimations && mv.availableAnimations.length > 0;
  }

  function finish() {
    current = null;
    window.clearTimeout(safety);
    viewers().forEach(function (mv) {
      try { mv.timeScale = 1; } catch (e) {}
    });
  }

  /** Plays a face once on every logo on the page. */
  function play(name, speed) {
    var list = viewers().filter(ready);
    if (!list.length) {
      pending = { name: name, speed: speed };
      return;
    }
    if (current && (current === name || PRIORITY[current] > PRIORITY[name])) return;
    if (list[0].availableAnimations.indexOf(name) < 0) return;
    asleep = false;
    current = name;
    var scale = speed || 1;
    list.forEach(function (mv) {
      try {
        mv.animationCrossfadeDuration = 0;
        mv.timeScale = scale;
        mv.animationName = name;
        mv.currentTime = 0;
        mv.play({ repetitions: 1 });
      } catch (e) {}
    });
    // in case 'finished' never comes (a hidden tab)
    window.clearTimeout(safety);
    safety = window.setTimeout(finish, 2600 / scale + 400);
  }

  /** Dozes off: Sleepy plays up to the sleepy eyes and stays there. */
  function sleep() {
    if (current || document.hidden) return;
    play('Sleepy');
    if (current !== 'Sleepy') return;
    window.setTimeout(function () {
      if (current !== 'Sleepy') return;
      window.clearTimeout(safety);
      viewers().filter(ready).forEach(function (mv) {
        try {
          mv.pause();
          mv.currentTime = SLEEP_HOLD_AT;
        } catch (e) {}
      });
      asleep = true;
    }, SLEEP_HOLD_AT * 1000 - 100);
  }

  /** Something happened: the rest of Sleepy plays (the eyes come back). */
  function wake() {
    if (!asleep) return;
    asleep = false;
    viewers().filter(ready).forEach(function (mv) {
      try { mv.play({ repetitions: 1 }); } catch (e) {}
    });
    window.clearTimeout(safety);
    safety = window.setTimeout(finish, 1600);
  }

  /** The Cursed eyes in the mouth's red (the anger mark PNG is the same red). */
  function tintCursedEyes(mv) {
    try {
      var eyes = mv.model && mv.model.getMaterialByName(CURSED_EYES_MATERIAL);
      if (!eyes) return;
      eyes.pbrMetallicRoughness.setBaseColorFactor(CURSED_EYES_COLOR);
      eyes.setEmissiveFactor([0, 0, 0]);
    } catch (e) {}
  }

  function angerMark(wrap) {
    if (!wrap || !wrap.querySelector('.fkx-logo-anger')) return;
    wrap.classList.add('is-angry');
    window.setTimeout(function () { wrap.classList.remove('is-angry'); }, 2500);
  }

  // ------------------------------------------------------------------------------------------------ clicks

  function onPointerDown(event) {
    downX = event.clientX;
    downY = event.clientY;
    moved = false;
  }

  function onPointerUp(event) {
    moved = Math.abs(event.clientX - downX) > 8 || Math.abs(event.clientY - downY) > 8;
  }

  function onLogoClick(event, wrap) {
    // the logo turns with a finger drag on phones: a drag is not a click
    event.preventDefault();
    event.stopImmediatePropagation();
    if (moved) {
      moved = false;
      return;
    }
    window.clearTimeout(logoTimer);
    var now = Date.now();
    gameStreak = now - gameLast < GAME_GAP_MS ? gameStreak + 1 : 1;
    gameLast = now;
    if (gameStreak >= GAME_CLICKS && window.fkxGameTrigger) {
      // kot się wkurza (Cursed + znak złości) i rozbija stronę grą
      gameStreak = 0;
      logoClicks = 0;
      current = null;
      play('Cursed');
      angerMark(wrap);
      window.fkxGameTrigger();
      return;
    }
    logoClicks += 1;
    if (logoClicks >= 3) {
      logoClicks = 0;
      current = null;
      play('Cursed');
      angerMark(wrap);
      return;
    }
    if (logoClicks === 1) play('Blink');
    var href = wrap.getAttribute('href') || (wrap.closest('a') && wrap.closest('a').getAttribute('href'));
    logoTimer = window.setTimeout(function () {
      logoClicks = 0;
      if (href && href !== '#' && new URL(href, location.href).href !== location.href) {
        if (!window.FkxNavigation || !window.FkxNavigation.visit || !window.FkxNavigation.visit(href)) {
          location.href = href;
        }
      }
    }, LOGO_NAV_DELAY_MS);
  }

  function onClick(event) {
    if (event.button != null && event.button !== 0) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var wrap = target.closest(WRAP);
    if (wrap && wrap.querySelector('model-viewer')) {
      onLogoClick(event, wrap);
      return;
    }
    if (target.closest(ADD_TO_CART)) {
      play('Dollars');
      return;
    }
    var link = target.closest('a[href]');
    if (link && HEARTS_LINK.test(link.getAttribute('href'))) {
      play('Hearts', HEARTS_SPEED);
      try { sessionStorage.setItem(CARRY_KEY, JSON.stringify({ name: 'Hearts', speed: HEARTS_SPEED, at: Date.now() })); } catch (e) {}
      return;
    }
    if (!reduceMotion) play('Happy', HAPPY_SPEED);
  }

  // ------------------------------------------------------------------------------------------------ idle and blinks

  function armIdle() {
    wake();
    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(function doze() {
      if (current || document.hidden) {
        // busy (or the tab hidden): try again a bit later
        idleTimer = window.setTimeout(doze, 2000);
        return;
      }
      sleep();
    }, IDLE_MS);
  }

  // ------------------------------------------------------------------------------------------------ start

  function onLoaded() {
    // a face waiting for the model (or carried over from the last page)
    var carried = null;
    try {
      carried = JSON.parse(sessionStorage.getItem(CARRY_KEY) || 'null');
      sessionStorage.removeItem(CARRY_KEY);
    } catch (e) {}
    if (pending) {
      var p = pending;
      pending = null;
      play(p.name, p.speed);
    } else if (carried && Date.now() - carried.at < 10000) {
      window.setTimeout(function () { play(carried.name, carried.speed); }, 300);
    }
  }

  function bindViewers() {
    viewers().forEach(function (mv) {
      if (mv.__fkxMoods) return;
      mv.__fkxMoods = true;
      mv.addEventListener('finished', finish);
      // every load (also a new src): the GLB comes back with its own colors
      mv.addEventListener('load', function () { tintCursedEyes(mv); });
      if (mv.loaded) tintCursedEyes(mv);
      if (mv.loaded) onLoaded();
      else mv.addEventListener('load', onLoaded, { once: true });
    });
  }

  function init() {
    bindViewers();
    window.addEventListener('pointerdown', onPointerDown, { capture: true, passive: true });
    window.addEventListener('pointerup', onPointerUp, { capture: true, passive: true });
    // window capture: before the old anger-mark script (it would count the same clicks again)
    window.addEventListener('click', onClick, { capture: true });
    ['pointermove', 'pointerdown', 'keydown', 'scroll', 'wheel', 'touchstart'].forEach(function (type) {
      window.addEventListener(type, armIdle, { capture: true, passive: true });
    });
    // the base theme's add-to-cart (product form, quick add, cart drawer); PUB_SUB_EVENTS is a global const, not on window
    /* global PUB_SUB_EVENTS, subscribe */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (!data || data.source === 'product-form') play('Dollars');
      });
    }
    document.addEventListener('shopify:section:load', bindViewers);
    document.addEventListener('ajax:loaded', bindViewers);
    armIdle();
  }

  window.__fkxLogoMoods = { play: play };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
